var _excluded = ["isOpen", "onClose", "overlayClassName", "contentClassName", "overlayStyle", "contentStyle", "children", "duration", "transitionProps", "disableAnimation"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";
import PropTypes from "prop-types";
import { DialogOverlay, DialogContent } from "@reach/dialog";
import { Transition } from "react-transition-group";
import classNames from "classnames";
var DURATION = 200; // use @reach/dialog for a11y reasons

var Modal2 = function Modal2(_ref) {
  var isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      overlayClassName = _ref.overlayClassName,
      contentClassName = _ref.contentClassName,
      overlayStyle = _ref.overlayStyle,
      contentStyle = _ref.contentStyle,
      children = _ref.children,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? DURATION : _ref$duration,
      transitionProps = _ref.transitionProps,
      disableAnimation = _ref.disableAnimation,
      props = _objectWithoutProperties(_ref, _excluded);

  // CSSTransition wouldn't work for me so just applied the classNames manually
  // TODO: fix exit transition
  return /*#__PURE__*/React.createElement(Transition, _extends({
    in: isOpen,
    timeout: duration,
    appear: true,
    unmountOnExit: true,
    mountOnEnter: true
  }, transitionProps), function (state) {
    return /*#__PURE__*/React.createElement(DialogOverlay, {
      className: overlayClassName,
      isOpen: isOpen,
      onDismiss: onClose,
      style: overlayStyle
    }, /*#__PURE__*/React.createElement(DialogContent, {
      style: contentStyle,
      className: classNames({
        "et--modal2": !disableAnimation
      }, contentClassName, state)
    }, children));
  });
};

Modal2.propTypes = {
  children: PropTypes.any,
  contentClassName: PropTypes.string,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  overlayClassName: PropTypes.string,
  overlayStyle: PropTypes.object,
  contentStyle: PropTypes.object,
  duration: PropTypes.number,
  transitionProps: PropTypes.object,
  disableAnimation: PropTypes.bool
};
export default Modal2;